/**
 * ReceivingBankAccountSelect — dropdown de contas de recebimento (billing REST).
 * Substitui o enum hardcoded `BankAccount`. Value = aliasName (chave aceita pelo backend,
 * legível); label = exibitionName. Envia-se aliasName como receiving_bank_account_id.
 */
import { useEffect, useState } from 'react';
import { listReceivingBankAccounts, ReceivingBankAccount } from '../../billing/services/receivingBankAccountApi';

interface Props {
    value: string;
    onChange: (aliasName: string) => void;
    className?: string;
    id?: string;
}

const SELECT_CLASS = 'w-full border dark:border-slate-600 rounded px-3 py-2 text-sm dark:bg-slate-700 dark:text-white';

const ReceivingBankAccountSelect: React.FC<Props> = ({ value, onChange, className, id }) => {
    const [accounts, setAccounts] = useState<ReceivingBankAccount[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let active = true;
        (async () => {
            try {
                const list = await listReceivingBankAccounts();
                if (!active) return;
                setAccounts(list);
                // seleciona a primeira conta quando o valor atual não está na lista
                if (list.length && !list.some(a => a.aliasName === value)) {
                    onChange(list[0].aliasName);
                }
            } catch {
                if (active) setAccounts([]);
            } finally {
                if (active) setLoading(false);
            }
        })();
        return () => { active = false; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <select
            id={id}
            className={className || SELECT_CLASS}
            value={value}
            disabled={loading}
            onChange={e => onChange(e.target.value)}
        >
            {loading && <option value={value}>Carregando…</option>}
            {!loading && accounts.length === 0 && <option value="">Nenhuma conta cadastrada</option>}
            {accounts.map(acc => (
                <option key={acc.aliasName} value={acc.aliasName}>{acc.exibitionName}</option>
            ))}
        </select>
    );
};

export default ReceivingBankAccountSelect;
